import react from "react"
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { startTour } from "./tourSlice";
import AdminTour from "./tour/AdminTour";
import { TOUR_STEPS } from "./tour/tourSteps";
import { selectSessionId } from "./sessionSlice";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessionId = useSelector(selectSessionId);
  const isSuperadmin = sessionId === "admin";

  const handleTakeTour = () => {
    dispatch(startTour());
    if (location.pathname !== TOUR_STEPS[0].page) {
      navigate(TOUR_STEPS[0].page);
    }
  };

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";

      const redirectGameSession=()=>{
        const raw = sessionStorage.getItem("userData");
        if (!raw) return;
        const parsed = JSON.parse(raw);
        const getGameId = parsed?.gameId;
        if (getGameId == null) return;
        window.location.href=process.env.REACT_APP_BASE_URL+"/active-games/"+getGameId;
      }

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i class="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div class="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{isSuperadmin && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Heart Smart </div>
          
         </div>
       
         
         <div style={{display: "flex", alignItems: "center", gap: "14px"}}>
           <button type="button" className="admin-tour-trigger" onClick={handleTakeTour}>
             <i className="fa-solid fa-signs-post" /> Take Tour
           </button>
           <div className="user">
              <img src="/admin/user.png"/>
           </div>
         </div>
       </div>
       {children}
       <AdminTour />
      </div>
}

export default Admin;
